<style scoped lang="less">
  .search {
    text-align: right;
  }
  .permission-tree {
    margin: 0 50px;
    height: 400px;
    overflow: auto;
  }
</style>
<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">系统</Breadcrumb-item>
        <Breadcrumb-item>权限组管理</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search">
      <Button type="primary" icon="plus-round"
      @click="onEdit('')">添加分组</Button>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/adminGroup/list"
          :params="queryParam" :onLoading="onLoading" :onSelection="onSelection"></List>

    <Modal title="编辑" v-model="editModal">
      <Form ref="form" class="form" :model="formData" :rules="formRule" :label-width="80">
        <Row>
          <i-col :span="22">
            <Form-item label="名称" prop="title">
              <Input v-model="formData.title"></Input>
            </Form-item>
          </i-col>
          <i-col :span="22">
            <Form-item label="描述" prop="description">
              <Input v-model="formData.description"></Input>
            </Form-item>
          </i-col>
          <i-col :span="11">
            <Form-item label="状态" prop="status">
              <Select v-model.number="formData.status">
                <Option v-for="item in statusList" :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </i-col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="editModal=false">取消</Button>
        <Button type="primary" size="large" :loading="loadingEdit" @click="edit">保存</Button>
      </div>
    </Modal>
    <Modal title="编辑权限" v-model="editPermissionModal">
      <el-tree ref="permissionTree" :data="permissionData" show-checkbox class="permission-tree" :check-strictly="true"  node-key="id" :default-checked-keys="checkKey"></el-tree>
      <div slot="footer">
        <Button type="text" size="large" @click="editPermissionModal=false">取消</Button>
        <Button type="primary" size="large" :loading="loadingEdit" @click="editPermission">保存</Button>
      </div>
    </Modal>
    <Modal title="关联知识库" v-model="kbBindModal">
      <p style="color:#808695;font-size:12px;margin-bottom:12px;">员工仅能问答此处勾选的库；与菜单权限分开。</p>
      <Select v-model="kbBindIds" multiple filterable style="width:100%;" :placeholder="kbBindPlaceholder">
        <Option v-for="b in kbAllBases" :value="String(b.id)" :key="b.id">{{ b.name }} ({{ b.externalKbId }})</Option>
      </Select>
      <div slot="footer">
        <Button type="text" size="large" @click="kbBindModal=false">取消</Button>
        <Button type="primary" size="large" :loading="kbBindSaving" @click="saveKbBind">保存</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import { KB_URI } from '@/tools/kbApi'
  export default {
    data () {
      let $constant = this.$constant
      let self = this
      return {
        searchLoading: false,
        reload: 0,
        queryParam: {},
        statusList: $constant.enabledStatus,
        loadingEdit: false,
        editModal: false,
        checkKey: [],
        formData: {
          id: '',
          title: '',
          description: '',
          status: 1,
        },
        formRule: {},
        editPermissionModal: false,
        kbBindModal: false,
        kbBindGroupId: null,
        kbBindIds: [],
        kbAllBases: [],
        kbBindSaving: false,
        kbBindPlaceholder: '请选择知识库',
        permissionData: [],
        departmentList: [],
        dingDeptReady: false,
        title: [
          {
            title: 'id',
            align: 'center',
            key: 'id',
          },
          {
            title: '名称',
            align: 'center',
            key: 'title',
          },
          {
            title: '描述',
            align: 'center',
            key: 'description',
          },
          {
            title: '状态',
            key: 'status',
            align: 'center',
            render: (h, params) => {
              let status = params.row.status
              let color = status === 0 ? 'red' : ''
              let statusEnum = $constant.getEnum($constant.enabledStatus, status)
              return h('div', {style: {color: color}}, statusEnum && statusEnum.text)
            },
          },
          {
            title: '钉钉部门',
            align: 'center',
            width: 200,
            render: (h, params) => {
              let row = params.row
              return h('Select', {
                style: {width: '160px'},
                props: {
                  value: row.dingDeptId ? String(row.dingDeptId) : '',
                  filterable: true,
                  clearable: true,
                  transfer: true,
                  placeholder: '请选择',
                },
                on: {
                  'on-change': (value) => {
                    if (!self.dingDeptReady) {
                      return
                    }
                    let nextId = value === undefined || value === null ? '' : String(value)
                    let current = row.dingDeptId ? String(row.dingDeptId) : ''
                    if (nextId === current) {
                      return
                    }
                    self.saveDingDept(row, nextId)
                  },
                },
              }, (self.departmentList || []).map(item => {
                let deptId = item.departmentId == null ? '' : String(item.departmentId)
                return h('Option', {props: {value: deptId}, key: deptId}, item.departmentName)
              }))
            },
          },
          {
            title: '钉钉部门 ID',
            align: 'center',
            width: 140,
            key: 'dingDeptId',
          },
          {
            title: '操作',
            // width: 150,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('div', [
                h('a', {
                  on: {
                    click: () => {
                      self.onEdit(params.row)
                    }
                  },
                }, '编辑'),
                h('span', {class: 'divider'}),
                h('a', {
                  on: {
                    click: () => {
                      if (row.id === 1) {
                        self.$Message.warning('超级管理员，不允许编辑')
                        return
                      }
                      self.onEditPermission(params.row)
                    }
                  }
                }, '权限'),
                h('span', {class: 'divider'}),
                h('a', {
                  on: {
                    click: () => {
                      self.onKbBind(params.row)
                    }
                  }
                }, '关联知识库'),
              ])
            },
          },
        ],
      }
    },
    mounted: function () {
      this.loadDingTalkGroup()
    },
    created: function () {
    },
    methods: {
      onKbBind (row) {
        this.kbBindGroupId = row.id
        this.kbBindIds = []
        this.kbAllBases = []
        this.kbBindPlaceholder = '加载中…'
        this.kbBindModal = true
        this.$http.post(KB_URI.groupBinds, { groupId: row.id }).then(res => {
          this.kbBindPlaceholder = '请选择知识库'
          if (res && res.status === 'ok' && res.data) {
            this.kbAllBases = res.data.allBases || []
            let binds = res.data.binds || []
            this.kbBindIds = binds.map(b => String(b.kbBaseId))
            if (!this.kbAllBases.length) {
              this.kbBindPlaceholder = '请先在「知识库」菜单同步库'
            }
          }
        }).catch(() => {
          this.kbBindPlaceholder = '加载失败'
        })
      },
      saveKbBind () {
        this.kbBindSaving = true
        this.$http.post(KB_URI.groupBind, {
          groupId: this.kbBindGroupId,
          kbBaseIds: (this.kbBindIds || []).join(',')
        }).then(res => {
          this.kbBindSaving = false
          if (res && res.status === 'ok') {
            this.$Message.success('已保存关联')
            this.kbBindModal = false
          }
        }).catch(() => { this.kbBindSaving = false })
      },
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
      onSelection (selection) {
        this.selection = selection
      },
      loadDingTalkGroup () {
        let self = this
        self.$http.get('/dingTalk/departmentList').then(function (res) {
          if (!res || !res.data) {
            return
          }
          self.departmentList = res.data
          setTimeout(function () {
            self.dingDeptReady = true
            self.search()
          }, 0)
        })
      },
      saveDingDept (row, value) {
        let self = this
        let dept = (self.departmentList || []).find(item => String(item.departmentId) === String(value))
        let data = {
          id: row.id,
          dingDeptId: value ? String(value) : '',
          dingDeptName: value && dept ? dept.departmentName : '',
        }
        self.$http.post('/adminGroup/saveAdminGroup', data).then(function (res) {
          if (res && res.status === 'ok') {
            row.dingDeptId = data.dingDeptId
            row.dingDeptName = data.dingDeptName
            self.$Message.success('提交成功!')
            self.search()
          }
        })
      },
      delAll () {
        this.$refs.dataList.delAll()
      },
      onEdit (row) {
        if (!row) {
          this.formData = {
            id: '',
            title: '',
            description: '',
            status: 1,
          }
          this.editModal = true
        }
        this.formData.id = row.id
        this.formData.title = row.title
        this.formData.status = row.status
        this.formData.description = row.description
        this.formData.superadmin = row.superadmin
        this.editModal = true
      },
      edit () {
        let self = this
        self.loadingEdit = true
        self.$refs.form.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingEdit = false
            return
          }
          let path = '/adminGroup/saveAdminGroup'
          self.$http.post(path, self.formData).then(function (res) {
            if (res && res.data > 0) {
              self.editModal = false
              self.$Message.success('提交成功!')
              self.search()
            }
            self.loadingEdit = false
          })
        })
      },
      editPermission () {
        let permissions = this.$refs.permissionTree.getCheckedNodes().map(item => item.id).join(',')

        this.loadingEdit = true
        let path = '/adminGroup/saveAdminGroup'

        this.$http.post(path, {id: this.permissionGroupId, rules: permissions}).then(res => {
          if (res && res.data > 0) {
            this.editPermissionModal = false
            this.$Message.success('提交成功!')
          }
          this.loadingEdit = false
        })
      },
      onEditPermission (row) {
        this.checkKey = []
        if (!row || !row.id) {
          return
        }
        this.permissionGroupId = row.id
        this.$http.get('/adminRule/queryAdminRuleDetailByParam', {params: {type: 'group', objectId: row.id}}).
          then(res => {
            if (!res || !res.data) {
              return
            }
            this.permissionData = res.data.map(item => {
              return this.treeNode(item)
            })

            this.editPermissionModal = true
          })
      },
      addCheckKeys (permissionDto) {
        if (permissionDto) {
          if (permissionDto.havePermission) {
            this.checkKey.push(permissionDto.id)
          }
        }
      },
      treeNode (permissionDto) {
        if (!permissionDto) {
          return
        }
        this.addCheckKeys(permissionDto)
        let treeNode = {
          id: permissionDto.id,
          label: permissionDto.title,
          expand: true,
          checked: permissionDto.havePermission,
          children: []
        }
        if (permissionDto.childAdminRuleDtoList) {
          treeNode.children = permissionDto.childAdminRuleDtoList.map(item => {
            return this.treeNode(item)
          })
        }

        return treeNode
      },
    },
  }

</script>



// WEBPACK FOOTER //
// AdminGroupList.vue?396d9022